module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin Betreiber 2.f31a83a3.svg";